import React from 'react';
import PropTypes from 'prop-types';
import style from './style.less';

export const TrackingImpressionPixel = ({ src }) => (
  <img
    data-testid='trackingPixel'
    className={style.trackingImpressionImg}
    height='1'
    width='1'
    src={src}
    alt=''
  />
);

TrackingImpressionPixel.propTypes = {
  src: PropTypes.string.isRequired,
};
